/* ============================================
   GIGLIOTTO TENUTE — Image Slideshow
   Reusable section; supports multiple instances
   ============================================ */

(function () {
  function initSlideshow(section) {
    const slides = section.querySelectorAll('.img-slideshow__slide');
    const dots   = section.querySelectorAll('.img-slideshow__dot');
    const arrows = section.querySelectorAll('.img-slideshow__arrow');
    if (slides.length <= 1) return;

    const speed = parseInt(section.dataset.autoplay, 10) || 5000;
    let current = 0;
    let timer   = null;

    function goTo(index) {
      slides[current].classList.remove('active');
      dots[current]?.classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current]?.classList.add('active');
    }

    function start() { timer = setInterval(() => goTo(current + 1), speed); }
    function stop()  { clearInterval(timer); }

    dots.forEach((dot, i) => dot.addEventListener('click', () => { stop(); goTo(i); start(); }));
    arrows.forEach(arrow => arrow.addEventListener('click', () => {
      stop();
      goTo(current + parseInt(arrow.dataset.dir, 10));
      start();
    }));

    // Touch/swipe support
    let touchStartX = 0;
    section.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    section.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { stop(); goTo(current + (diff > 0 ? 1 : -1)); start(); }
    }, { passive: true });

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);

    start();
  }

  document.querySelectorAll('.img-slideshow').forEach(initSlideshow);
})();
